import type { IntervalUnit } from "@chordcommerce/react-autonomy";

export function prepaidSubOptions({
  sku,
  interval: { unit, length },
  installmentCount,
}: {
  sku: string;
  interval: { unit: IntervalUnit; length: number };
  installmentCount: number;
}) {
  return {
    prepaidSubscription: {
      // `recurring: "subscription"` is required for sub rollover by OMS,
      // even though type definition specifies boolean
      recurring: "subscription",
      actionableDate: new Date(),
      installmentCount,
      interval: { length, units: unit },
      autoRedeem: true,
      gift: false,
      lineItems: [
        {
          sku,
          // This quantity MUST be 1, or it multiplies in Chord cart calculation.
          // Actual quantity MUST be handled by the outer quantity field
          // in order for cart to have the correct number of items at all.
          quantity: 1,
        },
      ],
    },
  };
}
